const deviations = {
    computed: {
        isTabletOrBigger() {
            return window.screen.width > 720;
        }
    },
    methods: {

        async orderProductOptions(location, product, order) {
            let blockShortage = false;
            if (product && product.amountLoaded && product.amountLoaded >= product.amount) {
                blockShortage = true;
            }
            const productId = location === 'loading' ? product.id : product.product.id;
            if (this.isTabletOrBigger) {
                let pickLocationId = product.id;
                let html = `<select class="form-control" id="select-action">` +
                    `<option value="" selected disabled>Select..</option>` +
                    `<option value="/register-deviation?location=${location}&locationAdditional=${product.productNumber}&blockShortage=${blockShortage}&orderId=${product.orderId}&recordId=${productId}&picklocation=${product.locationId}">${this.$root.$t('deviations.title')}</option>` +
                    `<option value="/undo-deviation?location=${location}&picklocation=${product.locationId ? product.locationId : 'nolocation'}&orderId=${product.orderId}&productNumber=${product.productNumber}">${this.$root.$t('shopfloor.deviations.undo')}</option>`
                    + `<option value="/trackandtrace/${product.productNumber}"</option>${this.$root.$t('shopfloor.trackAndTrace.watchTrackAndTrace')}</option>`;
                if (location == 'loading') {
                    let namedRouteForManualChange = product.name ? 'loading-manual-pick-location-change' : 'loading-manual-order-product-change'
                    html += `<option data-namedroute="${namedRouteForManualChange}"  value="/loading/manual?picklocation=${pickLocationId}">${this.$root.$t('shopfloor.teamlead.loading.manualAdjustment')}</option>`;
                }
                if (location == 'unloading') {
                    let namedRouteForManualChange = product.name ? 'teamlead-unloading-manual' : 'teamlead-unloading-manual'
                    html += `<option data-namedroute="${namedRouteForManualChange}"  value="/loading/manual?picklocation=${pickLocationId}">${this.$root.$t('shopfloor.teamlead.loading.manualAdjustment')}</option>`;
                }
                html += `</select>`;
                return this.createPopUp(html, {order, product});
            } else {
                return this.deviationOptions(location, product.productNumber, order, productId);
            }
        },
        async deviationOptions(location, additionalInfo, order, productId, locationId) {
            let html = `<select class="form-control" id="select-action">` +
                `<option value="" selected disabled>Select..</option>` +
                `<option value="/register-deviation?picklocation=${locationId}&location=${location}&locationAdditional=${additionalInfo}&orderId=${order.id}&recordId=${productId}">${this.$root.$t('deviations.title')}</option>` +
                `<option value="/undo-deviation?location=${location}&orderId=${order.id}&productNumber=${additionalInfo}">${this.$root.$t('shopfloor.deviations.undo')}</option>` +
                `<option value="/trackandtrace/${additionalInfo}">${this.$root.$t('shopfloor.trackAndTrace.watchTrackAndTrace')}</option>` +
                `</select>`;
            return this.createPopUp(html);
        },
        createPopUp(html, params = null) {
            navigator.vibrate(50);
            this.$swal({
                customClass: 'options-modal',
                title: this.$root.$t('whatDoYouWantToDo'),
                html,
                showConfirmButton: true,
                showCloseButton: true,
                preConfirm: function (result) {
                    return new Promise(function (resolve) {

                        let namedRoute = $('#select-action').find(':selected').data('namedroute');
                        let path = $('#select-action').val();

                        resolve({path, namedRoute});
                    });
                }
            }).then(res => {
                if (res.dismiss) {
                    return
                }
                if (res !== null) {
                    if (res.value.namedRoute) {
                        this.$router.push({name: res.value.namedRoute, params: params});
                    } else {
                        this.$router.push({path: res.value.path});
                    }
                }
            });
        }
    }
};

export {
    deviations
};
